export const OPTIMISTIC_SWITCH_KIND = {
  CAMPAIGN: "campaign",
  ASSETS_GROUP: "assetsGroup",
  AD_GROUP: "adGroup",
  AD: "ad",
  AUTOMATION: "automation",
  PROMO_CODE: "promoCode",
};

export const OPTIMISTIC_SWITCH_ACTION = {
  ACTIVATE: "activate",
  DEACTIVATE: "deactivate",
};
